// extracted by mini-css-extract-plugin
export default {"buttonContainer":"CountdownButton_buttonContainer__yxSN5","timeTrack":"CountdownButton_timeTrack__-fLZL","tooltiptext":"CountdownButton_tooltiptext__RrAXP"};